import { getAlgoSpaceConfig } from "../firebase-config";
import { captureEvent } from "../helpers";
const LOGO_BASE_URL = "https://images.5paisa.com/fno/assets/logos";
const CAROUSEL_IMAGES_BASE_URL = "https://images.5paisa.com/fno/assets/carousel-images";
const FNO360_URL = "https://fno.5paisa.com/";
const TTWEB_URL = "https://ttweb.5paisa.com/";
const SCALPER_URL = "http://fno.5paisa.com/scalper";
const XSTREAM_URL = "https://xstream.5paisa.com/";
const ALGOSPACE_URL = "https://algospace.5paisa.com";
function getAlgoConfig() {
    const defaultConfig = { isAlgoVisible: true, algospaceTagText: "NEW" };
    try {
        const data = sessionStorage.getItem("ALGO_SPACE");
        if (!data)
            return defaultConfig;
        return JSON.parse(data);
    }
    catch (_a) {
        return defaultConfig;
    }
}
let isAlgoVisible = false;
let algospaceConfig = await getAlgoSpaceConfig();
isAlgoVisible = algospaceConfig.isAlgoVisible;
let alogoObj = {
    id: "algospace",
    logo: `${LOGO_BASE_URL}/algospacelogo.svg`,
    label: "Algospace",
    shortDescription: "Trade smarter with ready-made expert algos",
    productLink: ALGOSPACE_URL,
    imagesArray: [
        {
            imageLink: `${CAROUSEL_IMAGES_BASE_URL}/common/all-algos.png`,
            tooltip: {
                position: "right",
                heading: "Built by experts, designed for everyday traders",
                caption: "Trade with strategies built by seasoned professionals",
            },
        },
        {
            imageLink: `${CAROUSEL_IMAGES_BASE_URL}/common/about-algos.png`,
            tooltip: {
                position: "top",
                heading: "Full transparency: see backtest details upfront",
                caption: "Understand how each algo performs before you start",
            },
        },
        {
            imageLink: `${CAROUSEL_IMAGES_BASE_URL}/common/deploy.png`,
            tooltip: {
                position: "left",
                heading: "Go live instantly in just a few clicks",
                caption: "No setup, no delays : start trading right away",
            },
        },
        {
            imageLink: `${CAROUSEL_IMAGES_BASE_URL}/common/deploy-section.png`,
            tooltip: {
                position: "right",
                heading: "One simple dashboard to track all your algos",
                caption: "Monitor all algos with live P&L in one place",
            },
        },
        {
            imageLink: `${CAROUSEL_IMAGES_BASE_URL}/common/view-details-2.png`,
            tooltip: {
                position: "left",
                heading: "Drill down into your algo's live performance anytime",
                caption: "Access detailed insights whenever you need",
            },
        },
    ],
};
function getProductList(theme) {
    return [
        {
            id: "fno360",
            logo: `${LOGO_BASE_URL}/fnologo.svg`,
            label: "FnO360",
            shortDescription: "A trading terminal designed exclusively for derivative traders",
            productLink: FNO360_URL,
            imagesArray: [
                {
                    imageLink: `${CAROUSEL_IMAGES_BASE_URL}/${theme}/fno1.png`,
                    tooltip: {
                        position: "right",
                        heading: "Unified FNO360 Dashboard",
                        caption: "All F&O insights like Option Chain, Greeks, OI, Charts, VIX and Screeners in one unified view.",
                    },
                },
                {
                    imageLink: `${CAROUSEL_IMAGES_BASE_URL}/${theme}/fno2.png`,
                    tooltip: {
                        position: "top",
                        heading: "Option Chain Power Features",
                        caption: "Place single or multi-leg orders, trade straddles, create strategies, analyze them, access advanced Greeks, compare indices, and track live P&L.",
                    },
                },
                {
                    imageLink: `${CAROUSEL_IMAGES_BASE_URL}/${theme}/fno3.png`,
                    tooltip: {
                        position: "right",
                        heading: "Open Interest Insights",
                        caption: "Track real-time OI changes, analyze multi-strike trends, compare Call vs Put OI, view PCR with price, and identify Max Pain for better market direction.",
                    },
                },
                {
                    imageLink: `${CAROUSEL_IMAGES_BASE_URL}/${theme}/fno4.png`,
                    tooltip: {
                        position: "left",
                        heading: "Strategy Builder",
                        caption: "Create or Trade multi-leg strategies with ready-made setups, detailed Greeks, and payoff charts, plus quick what-if analysis to evaluate scenarios.",
                    },
                },
                {
                    imageLink: `${CAROUSEL_IMAGES_BASE_URL}/${theme}/fno5.png`,
                    tooltip: {
                        position: "top",
                        heading: "F&O Stats & Insights",
                        caption: "Visualize market activity with heatmaps, track ban stocks, analyze futures buildup, monitor index contributors, compare VIX trends, spot momentum, and follow FII/DII positioning all in one place.",
                    },
                },
            ],
        },
        ...(isAlgoVisible ? [alogoObj] : []),
        {
            id: "ttweb",
            logo: `${LOGO_BASE_URL}/ttweblogo.svg`,
            label: "Trader's Terminal",
            shortDescription: "A web-based trading platform for seamless execution",
            productLink: TTWEB_URL,
            imagesArray: [
                {
                    imageLink: `${CAROUSEL_IMAGES_BASE_URL}/${theme}/ttweb1.png`,
                    tooltip: {
                        position: "right",
                        heading: "TTWeb Smart Dashboard",
                        caption: "Track holdings, P&L, margin, market movers, and access trading opportunities across equity, F&O, and more—all from one unified screen.",
                    },
                },
                {
                    imageLink: `${CAROUSEL_IMAGES_BASE_URL}/${theme}/ttweb2.png`,
                    tooltip: {
                        position: "top",
                        heading: "Smart Watchlist & Stock Info",
                        caption: "Track stocks, monitor live P&L, and access detailed company fundamentals, technicals, and insights with instant trade actions.",
                    },
                },
                {
                    imageLink: `${CAROUSEL_IMAGES_BASE_URL}/${theme}/ttweb3.png`,
                    tooltip: {
                        position: "right",
                        heading: "Alpha Scan & Smart Screeners",
                        caption: "Discover trading opportunities using technical, fundamental, momentum, and expert-based screeners with instant buy/sell actions. ",
                    },
                },
            ],
        },
        {
            id: "scalper",
            logo: `${LOGO_BASE_URL}/scalperlogo.svg`,
            label: "Scalper",
            shortDescription: "Lightning-fast scalping interface with instant keyboard execution",
            productLink: SCALPER_URL,
            imagesArray: [
                {
                    imageLink: `${CAROUSEL_IMAGES_BASE_URL}/${theme}/scalper.png`,
                    tooltip: {
                        position: "right",
                        heading: "Scalper Terminal",
                        caption: "Designed for traders who thrive on speed, precision, and quick decision-making. One-tap trading.",
                    },
                },
            ],
        },
        {
            id: "xstream",
            logo: `${LOGO_BASE_URL}/xstreamlogo-${theme}.svg`,
            label: "Xstream APIs",
            shortDescription: "Revolutionize your trading API journey",
            productLink: XSTREAM_URL,
            imagesArray: [
                {
                    imageLink: `${CAROUSEL_IMAGES_BASE_URL}/common/xstream.png`,
                    tooltip: {
                        position: "top",
                        heading: "Xstream APIs",
                        caption: "Unleash the future of trading with our free, fast, and simple API platform.",
                    },
                },
            ],
        }
    ];
}
// ─── Carousel state 
let carouselCurrent = 0;
let carouselIsPaused = false;
let carouselImages = [];
let carouselProductId = null;
let carouselTimeoutRef = null;
let carouselStartTimeRef = Date.now();
let carouselRemainingTimeRef = 4000;
// Tracks when the mouse entered the image container (for the 200ms)
let carouselMouseEnterTimeRef = 0;
function stopCarousel() {
    if (carouselTimeoutRef !== null) {
        clearTimeout(carouselTimeoutRef);
        carouselTimeoutRef = null;
    }
}
/**
 * - If not paused: record start time, schedule next tick after remainingTime
 * - If paused: clear timeout, subtract elapsed from remaining
 */
function scheduleCarouselTick() {
    stopCarousel();
    if (carouselImages.length === 0)
        return;
    if (!carouselIsPaused) {
        carouselStartTimeRef = Date.now();
        carouselTimeoutRef = setTimeout(() => {
            carouselCurrent = (carouselCurrent + 1) % carouselImages.length;
            carouselRemainingTimeRef = 4000;
            renderCarouselFrame();
            scheduleCarouselTick();
        }, carouselRemainingTimeRef);
    }
}
/**
 * Called when mouse enters image container or dots.
 * Pauses the carousel and records the enter time.
 */
function carouselHandleMouseEnter() {
    carouselMouseEnterTimeRef = Date.now();
    if (!carouselIsPaused) {
        // Pause: record elapsed and subtract from remaining
        const elapsed = Date.now() - carouselStartTimeRef;
        carouselRemainingTimeRef = Math.max(0, carouselRemainingTimeRef - elapsed);
        carouselIsPaused = true;
        stopCarousel();
    }
}
/**
 * Called when mouse leaves image container or dots.
 * - If mouse was on the image for ≥ 200ms → advance to next slide immediately.
 * - Otherwise (quick pass-through) → just resume the timer with remaining time.
 */
function carouselHandleMouseLeave() {
    if (carouselIsPaused) {
        const hoverDuration = Date.now() - carouselMouseEnterTimeRef;
        const shouldAdvance = hoverDuration >= 200 || carouselRemainingTimeRef <= 0;
        if (shouldAdvance && carouselImages.length > 1) {
            carouselCurrent = (carouselCurrent + 1) % carouselImages.length;
            carouselRemainingTimeRef = 4000;
            renderCarouselFrame();
        }
        carouselIsPaused = false;
        scheduleCarouselTick();
    }
}
//Start carousel for a new product
function startCarousel(images, productId) {
    stopCarousel();
    carouselImages = images;
    carouselProductId = productId;
    carouselCurrent = 0;
    carouselIsPaused = false;
    carouselRemainingTimeRef = 4000;
    renderCarouselFrame();
    scheduleCarouselTick();
}
/**
 * Render the current carousel frame:
 * active image
 * active dot
 * tooltip (position, heading, caption, theme)
 */
function renderCarouselFrame() {
    var _a;
    const container = document.getElementById("pw-carousel-images");
    const dotsContainer = document.getElementById("pw-carousel-dots");
    const tooltipWrapper = document.getElementById("pw-tooltip-wrapper");
    if (!container || !dotsContainer || !tooltipWrapper)
        return;
    // Update image visibility
    const imgs = container.querySelectorAll(".products_wrapper__carousel-image");
    imgs.forEach((img, i) => {
        img.classList.toggle("products_wrapper__carousel-image--active", i === carouselCurrent);
    });
    // Update dots
    const dots = dotsContainer.querySelectorAll(".products_wrapper__carousel-dot");
    dots.forEach((dot, i) => {
        dot.classList.toggle("products_wrapper__carousel-dot--active", i === carouselCurrent);
    });
    // Update tooltip
    const tooltip = (_a = carouselImages[carouselCurrent]) === null || _a === void 0 ? void 0 : _a.tooltip;
    if (!tooltip)
        return;
    // xstream always uses "light" tooltip theme (mirrors React: id == ProductId.XSTREAM ? "light" : theme)
    const tooltipTheme = carouselProductId === "xstream" ? "light" : currentTheme;
    tooltipWrapper.className = `products_wrapper__tooltip-wrapper products_wrapper__tooltip-wrapper--${tooltip.position}`;
    const tooltipEl = tooltipWrapper.querySelector(".products_wrapper__tooltip");
    const headingEl = tooltipWrapper.querySelector(".products_wrapper__tooltip-heading");
    const captionEl = tooltipWrapper.querySelector(".products_wrapper__tooltip-caption");
    if (tooltipEl)
        tooltipEl.className = `products_wrapper__tooltip products_wrapper__tooltip--${tooltipTheme}`;
    if (headingEl) {
        headingEl.className = `products_wrapper__tooltip-heading products_wrapper__tooltip-heading--${tooltipTheme}`;
        headingEl.textContent = tooltip.heading;
    }
    if (captionEl) {
        captionEl.className = `products_wrapper__tooltip-caption products_wrapper__tooltip-caption--${tooltipTheme}`;
        captionEl.textContent = tooltip.caption;
    }
}
// Build popup DOM 
function buildPopupDOM(products, algospaceTagText = "NEW") {
    const popup = document.createElement("div");
    popup.id = "pw-popup";
    popup.className = "products_wrapper__popup";
    // ── Left menu 
    const menu = document.createElement("div");
    menu.className = "products_wrapper__menu";
    products.forEach((product, idx) => {
        const item = document.createElement("div");
        item.className =
            "products_wrapper__item" + (idx === 0 ? " products_wrapper__item--active" : "");
        item.dataset.productId = product.id;
        // Logo image
        const logo = document.createElement("img");
        logo.src = product.logo;
        logo.alt = product.label;
        // Info block
        const info = document.createElement("div");
        info.className = "products_wrapper__item-info";
        if (product.id === "algospace") {
            const titleContainer = document.createElement("div");
            titleContainer.className = "products_wrapper__title-container";
            const titleImg = document.createElement("img");
            titleImg.src = `${LOGO_BASE_URL}/algospace-title${currentTheme}.svg`;
            titleImg.alt = "algospace";
            const badge = document.createElement("span");
            const badgeType = algospaceTagText === "NEW" ? "new" : "beta";
            badge.className = `products_wrapper__badge products_wrapper__badge--${badgeType}`;
            badge.textContent = algospaceTagText;
            titleContainer.appendChild(titleImg);
            titleContainer.appendChild(badge);
            info.appendChild(titleContainer);
        }
        else {
            const label = document.createElement("h3");
            label.textContent = product.label;
            label.className = "regularWeight";
            info.appendChild(label);
        }
        const desc = document.createElement("p");
        desc.textContent = product.shortDescription;
        info.appendChild(desc);
        item.appendChild(logo);
        item.appendChild(info);
        menu.appendChild(item);
    });
    // Right display panel
    const display = document.createElement("div");
    display.className = "products_wrapper__display";
    const displayBottom = document.createElement("div");
    displayBottom.className = "products_wrapper__display-bottom";
    const carousel = document.createElement("div");
    carousel.className = "products_wrapper__carousel";
    const tooltipWrapper = document.createElement("div");
    tooltipWrapper.id = "pw-tooltip-wrapper";
    tooltipWrapper.className = "products_wrapper__tooltip-wrapper products_wrapper__tooltip-wrapper--right";
    const tooltipEl = document.createElement("div");
    tooltipEl.className = `products_wrapper__tooltip products_wrapper__tooltip--${currentTheme}`;
    const tooltipContent = document.createElement("div");
    tooltipContent.className = "products_wrapper__tooltip-content";
    const tooltipHeading = document.createElement("h4");
    tooltipHeading.className = `products_wrapper__tooltip-heading products_wrapper__tooltip-heading--${currentTheme}`;
    const tooltipCaption = document.createElement("p");
    tooltipCaption.className = `products_wrapper__tooltip-caption products_wrapper__tooltip-caption--${currentTheme}`;
    tooltipContent.appendChild(tooltipHeading);
    tooltipContent.appendChild(tooltipCaption);
    tooltipEl.appendChild(tooltipContent);
    tooltipWrapper.appendChild(tooltipEl);
    // Image container
    const imageContainer = document.createElement("div");
    imageContainer.id = "pw-carousel-images";
    imageContainer.className = "products_wrapper__carousel-image-container";
    // Mouse pause/resume on image container
    imageContainer.addEventListener("mouseenter", carouselHandleMouseEnter);
    imageContainer.addEventListener("mouseleave", carouselHandleMouseLeave);
    // Controls: grid layout 
    const controls = document.createElement("div");
    controls.className = "products_wrapper__carousel-controls";
    // Empty left spacer (grid column 1)
    const leftSpacer = document.createElement("div");
    // Dots container (grid column 2 — centered)
    const dotsContainer = document.createElement("div");
    dotsContainer.id = "pw-carousel-dots";
    dotsContainer.className = "products_wrapper__carousel-dots";
    // Mouse pause/resume on dots 
    dotsContainer.addEventListener("mouseenter", carouselHandleMouseEnter);
    dotsContainer.addEventListener("mouseleave", carouselHandleMouseLeave);
    // Explore link (grid column 3 — right aligned via margin-left: auto)
    const exploreLink = document.createElement("a");
    exploreLink.id = "pw-explore-link";
    exploreLink.className = "products_wrapper__display-link";
    exploreLink.textContent = "Explore";
    exploreLink.target = "_blank";
    exploreLink.rel = "noopener noreferrer";
    controls.appendChild(leftSpacer);
    controls.appendChild(dotsContainer);
    controls.appendChild(exploreLink);
    carousel.appendChild(tooltipWrapper);
    carousel.appendChild(imageContainer);
    carousel.appendChild(controls);
    displayBottom.appendChild(carousel);
    display.appendChild(displayBottom);
    popup.appendChild(menu);
    popup.appendChild(display);
    return popup;
}
/**
 * Populate image elements and dot elements for the selected product.
 * Called every time a new product is selected.
 */
function populateCarouselImages(images) {
    const container = document.getElementById("pw-carousel-images");
    const dotsContainer = document.getElementById("pw-carousel-dots");
    if (!container || !dotsContainer)
        return;
    container.innerHTML = "";
    dotsContainer.innerHTML = "";
    images.forEach((img, i) => {
        // Image ele
        const imgEl = document.createElement("img");
        imgEl.src = img.imageLink;
        imgEl.alt = `slide-${i}`;
        imgEl.className =
            "products_wrapper__carousel-image" +
                (i === 0 ? " products_wrapper__carousel-image--active" : "");
        container.appendChild(imgEl);
        // Dot ele
        const dot = document.createElement("span");
        dot.className =
            "products_wrapper__carousel-dot" +
                (i === 0 ? " products_wrapper__carousel-dot--active" : "");
        dot.addEventListener("click", () => {
            carouselCurrent = i;
            carouselRemainingTimeRef = 4000;
            renderCarouselFrame();
            // Restart timer from this index
            if (!carouselIsPaused) {
                scheduleCarouselTick();
            }
        });
        dotsContainer.appendChild(dot);
    });
}
// states 
let isOpen = false;
let currentTheme = "light";
let currentProducts = [];
let selectedProduct = null;
let popupEl = null;
let triggerEl = null;
let closeTimeout = null;
let openTimeout = null;
let analyticsTimeout = null;
// call this fun in main.ts
export function initProductsPopup(productsButton, theme, _clientCode) {
    currentTheme = theme === "dark" ? "dark" : "light";
    triggerEl = productsButton;
    const { isAlgoVisible, algospaceTagText } = getAlgoConfig();
    const allProducts = getProductList(currentTheme);
    currentProducts = allProducts.filter((p) => {
        if (p.id === "algospace")
            return isAlgoVisible;
        return true;
    });
    selectedProduct = currentProducts[0];
    // Build and append popup to body
    popupEl = buildPopupDOM(currentProducts, algospaceTagText);
    document.body.appendChild(popupEl);
    wireMenuItems();
    // open product link
    const display = popupEl.querySelector(".products_wrapper__display");
    if (display) {
        display.addEventListener("click", () => {
            if (selectedProduct) {
                //  product_click`
                fireAnalytics(selectedProduct.id === "algospace" ? "algo_space_click" : "product_click", { product_name: selectedProduct.label });
                window.open(selectedProduct.productLink, "_blank", "noopener,noreferrer");
            }
        });
    }
    // Hover on trigger button 
    productsButton.addEventListener("mouseenter", handleMouseEnter);
    productsButton.addEventListener("mouseleave", handleMouseLeave);
    // Hover on popup itself (keep open) 
    popupEl.addEventListener("mouseenter", () => {
        if (closeTimeout !== null) {
            clearTimeout(closeTimeout);
            closeTimeout = null;
        }
        if (openTimeout !== null) {
            clearTimeout(openTimeout);
        }
        // Keep popup open
        if (!isOpen) {
            openPopup();
        }
    });
    popupEl.addEventListener("mouseleave", handleMouseLeave);
    // Close on outside click
    document.addEventListener("click", (e) => {
        if (isOpen &&
            popupEl &&
            !popupEl.contains(e.target) &&
            !productsButton.contains(e.target)) {
            closePopup();
        }
    });
}
export function updateProductsPopupTheme(theme) {
    currentTheme = theme === "dark" ? "dark" : "light";
    const { isAlgoVisible, algospaceTagText } = getAlgoConfig();
    const allProducts = getProductList(currentTheme);
    currentProducts = allProducts.filter((p) => {
        if (p.id === "algospace")
            return isAlgoVisible;
        return true;
    });
    if (popupEl) {
        const menu = popupEl.querySelector(".products_wrapper__menu");
        if (menu) {
            const items = menu.querySelectorAll(".products_wrapper__item");
            items.forEach((item, i) => {
                const productId = item.dataset.productId;
                const product = currentProducts[i];
                if (!product)
                    return;
                const logo = item.querySelector(":scope > img");
                if (logo)
                    logo.src = product.logo;
                if (productId === "algospace") {
                    const titleImg = item.querySelector(".products_wrapper__title-container img");
                    if (titleImg) {
                        titleImg.src = `${LOGO_BASE_URL}/algospace-title${currentTheme}.svg`;
                    }
                    // Update badge text in case config changed
                    const badge = item.querySelector(".products_wrapper__badge");
                    if (badge) {
                        const badgeType = algospaceTagText === "NEW" ? "new" : "beta";
                        badge.className = `products_wrapper__badge products_wrapper__badge--${badgeType}`;
                        badge.textContent = algospaceTagText;
                    }
                }
            });
        }
        if (isOpen && selectedProduct) {
            const updatedProduct = currentProducts.find((p) => p.id === selectedProduct.id);
            if (updatedProduct) {
                selectedProduct = updatedProduct;
                populateCarouselImages(selectedProduct.imagesArray);
                startCarousel(selectedProduct.imagesArray, selectedProduct.id);
            }
        }
    }
}
//Helper Functions
function wireMenuItems() {
    if (!popupEl)
        return;
    const items = popupEl.querySelectorAll(".products_wrapper__item");
    items.forEach((item) => {
        // Hover select product 
        item.addEventListener("mouseenter", () => {
            const productId = item.dataset.productId;
            const product = currentProducts.find((p) => p.id === productId);
            if (product)
                handleProductHover(product);
        });
        // Click open product link 
        item.addEventListener("click", (e) => {
            e.stopPropagation();
            const productId = item.dataset.productId;
            const product = currentProducts.find((p) => p.id === productId);
            if (!product)
                return;
            fireAnalytics(product.id === "algospace" ? "algo_space_click" : "product_click", { product_name: product.label });
            window.open(product.productLink, "_blank", "noopener,noreferrer");
        });
    });
}
function handleProductHover(product) {
    selectedProduct = product;
    if (popupEl) {
        const items = popupEl.querySelectorAll(".products_wrapper__item");
        items.forEach((item) => {
            item.classList.toggle("products_wrapper__item--active", item.dataset.productId === product.id);
        });
    }
    const exploreLink = document.getElementById("pw-explore-link");
    if (exploreLink)
        exploreLink.href = product.productLink;
    if (analyticsTimeout !== null)
        clearTimeout(analyticsTimeout);
    analyticsTimeout = setTimeout(() => {
        fireAnalytics("product_hover", { product_name: product.label });
    }, 400);
    populateCarouselImages(product.imagesArray);
    startCarousel(product.imagesArray, product.id);
}
function handleMouseEnter() {
    if (closeTimeout !== null) {
        clearTimeout(closeTimeout);
        closeTimeout = null;
    }
    if (openTimeout !== null) {
        clearTimeout(openTimeout);
    }
    openTimeout = setTimeout(() => {
        if (!isOpen) {
            selectedProduct = currentProducts[0];
        }
        openPopup();
    }, 200);
}
function handleMouseLeave() {
    if (openTimeout !== null) {
        clearTimeout(openTimeout);
        openTimeout = null;
    }
    if (closeTimeout !== null) {
        clearTimeout(closeTimeout);
    }
    closeTimeout = setTimeout(() => {
        closePopup();
    }, 200);
}
function openPopup() {
    var _a;
    if (!popupEl || !triggerEl)
        return;
    isOpen = true;
    popupEl.style.display = "flex";
    if (selectedProduct) {
        const refreshed = currentProducts.find((p) => p.id === selectedProduct.id);
        if (refreshed)
            selectedProduct = refreshed;
    }
    else {
        selectedProduct = (_a = currentProducts[0]) !== null && _a !== void 0 ? _a : null;
    }
    if (selectedProduct) {
        populateCarouselImages(selectedProduct.imagesArray);
        startCarousel(selectedProduct.imagesArray, selectedProduct.id);
        const exploreLink = document.getElementById("pw-explore-link");
        if (exploreLink)
            exploreLink.href = selectedProduct.productLink;
        if (popupEl) {
            const items = popupEl.querySelectorAll(".products_wrapper__item");
            items.forEach((item) => {
                item.classList.toggle("products_wrapper__item--active", item.dataset.productId === selectedProduct.id);
            });
        }
    }
    fireAnalytics("products_tab_hover");
}
function closePopup() {
    if (!popupEl)
        return;
    isOpen = false;
    popupEl.style.display = "none";
    stopCarousel();
}
//CaptureEvent 
function fireAnalytics(eventName, extraProps = {}) {
    const props = {
        ClientCode: localStorage.getItem("ClientCode"),
        Chart_Type_Selected: "Trading View",
        ...extraProps,
    };
    try {
        captureEvent(eventName, props);
    }
    catch (err) {
        console.error(`[ProductsPopup] captureEvent failed for "${eventName}":`, err);
    }
}
